<div class="workshift-info" (click)="onClick()">

  <div>
    <span placement="top" [ngbPopover]='model?.jobAndUnitInfo.fullDescription' triggers="mouseenter:mouseleave"  >{{model?.jobAndUnitInfo?.job?.description}}</span>

    <ng-template #plan >

      <ng-template [ngIf]="!isPlanningOK()">
        <div>
        <ul>
        <li *ngFor="let k of retrieveMissingErrors()">
          {{k}}
        </li>
        <li *ngFor="let k of retrieveTooManyErrors()">
          {{k}}
        </li>
        </ul>
      </div></ng-template>



    </ng-template>

    <ng-template [ngIf]="!isPlanningOK()"><span class="emprez-orange-fiesta" placement="top" [ngbPopover]='plan' triggers="mouseenter:mouseleave"  >&nbsp;<i class="fa fa-certificate"></i></span></ng-template>
    <ng-template [ngIf]="isPlanningOK() && model.planned"><span class="emprez-vert-agrume">&nbsp;<i class="fa fa-certificate"></i></span></ng-template>
  </div>
  <!--<div class="muted">{{weeklyWorkShiftComponent.info.inputs.startTime}}-{{weeklyWorkShiftComponent.info.inputs.endTime}}</div>-->
  <div class="muted">{{model.startTime | myDateFormat:'LT'}}-{{model.endTime | myDateFormat:'LT'}}</div>

</div>
